import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { GlobalService } from '../../services/global.service';
import { Title } from '@angular/platform-browser';
import { HttpService } from '../../services/http.service';
import { Globals } from '../../models/globals.model';
import { ConstantModel } from '../kpi-models/constants.model';
import { AlertComponent } from '../../common/alert/alert.component';
import { ConfirmModelComponent } from '../../common/confirm-model/confirm-model.component';
import { HttpParams } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { ConstantModalComponent } from '../constant-modal/constant-modal.component';
import { FilterModel } from '../../models/filter/filter-request.model';
import { FilterResponseModel } from '../../models/filter/filter-response.model';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { FilterFieldTypes } from '../../shared/common-constants';
import { KPIFormulaBuilderService } from 'src/app/services/kpi-formula-builder.service';

@Component({
  selector: 'app-constants',
  templateUrl: './constants.component.html',
  styleUrls: ['./constants.component.css']
})
export class ConstantsComponent implements OnInit {

  isLoader = false;
  emptyData = false;
  displayedColumns: string[] = ['add', 'constantId', 'value', 'uom', 'lastModifiedBy', 'action'];
  constantsDataSource: MatTableDataSource<ConstantModel>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  selectedConstant: ConstantModel;

  apiUri: string;
  graphUri: string;
  searchText: string = "";
  filterList: FilterModel[] = [];
  selectedFilters: FilterResponseModel[] = [];
  masterData: ConstantModel[];
  @ViewChild('popOver') public popover: NgbPopover;

  constructor(public globalService: GlobalService, private readonly kpiFormulaService: KPIFormulaBuilderService,
    private readonly titleService: Title, private readonly httpService: HttpService,
    public global: Globals, public dialog: MatDialog) {
      const emptyList: any[] = [];
      this.constantsDataSource = new MatTableDataSource(emptyList);
    titleService.setTitle('Constants');
    this.apiUri = this.global.config.foundationPlatformApi_client_resourceUri;
    this.graphUri = this.global.config.graphApi_client_resourceUri;
  }

  ngOnInit(): void {
    this.getConstantsData(this);
    this.isLoader = false;
  }

  /** Fetches list of constant data*/
  getConstantsData(thisRef: ConstantsComponent) {
    thisRef.isLoader = true;
    thisRef.kpiFormulaService.getConstantsFormula().subscribe((data: any): void => {
      if (data.length > 0) {
        thisRef.masterData = [...data];
        thisRef.isLoader = false;
        thisRef.constantsDataSource = new MatTableDataSource(data);
        thisRef.constantsDataSource.paginator = thisRef.paginator;
        thisRef.constantsDataSource.sort = thisRef.sort;
        if (thisRef.globalService.isNotNull(thisRef.searchText)) {
          thisRef.globalService.applyFilter(thisRef.searchText, thisRef.constantsDataSource);
        }
        if (thisRef.filterList.length == 0) {
          thisRef.createFilterList();
        }
      } else {
        thisRef.emptyData = true;
        thisRef.isLoader = false;
        thisRef.constantsDataSource = new MatTableDataSource(data);
      }
    }, (error) => {
      thisRef.isLoader = false;
    });
  }

  /**
   * Delete model
   * @param element
   */
  deleteModel(element: ConstantModel) {
    const dataToPass = {
      title: 'Delete',
      isDelete: true,
      message: 'Do you really want to delete the constant ' + element.constantId + '?'
    };
    this.selectedConstant = element;
    this.globalService.openModelWindow(this.deleteModelAfterConfirmation,
      this, ConfirmModelComponent, '450px', 'confirm-modalbox', dataToPass);
  }

  setSearchText(filterValue: string) {
    filterValue = filterValue.trim().toLowerCase();
    this.searchText = filterValue;
  }

  /**
   * Delete cleansing rule after confirmation
   * @param thisRef
   */
  deleteModelAfterConfirmation(thisRef: ConstantsComponent) {    
    thisRef.kpiFormulaService.deleteConstantModel(thisRef.selectedConstant.constantId).subscribe((data: any): void => {
      thisRef.isLoader = false;
      thisRef.globalService.showAlert(AlertComponent, { success: true, message: 'Constants for ' + thisRef.selectedConstant.constantId + ' deleted successfully.' });
      thisRef.getConstantsData(thisRef);
    }, (error) => {
      thisRef.isLoader = false;
    });
  }

  /**
   * Edit details
   * @param element
   */
  editDetails(element: ConstantModel) {
    this.globalService.openModelWindowSmall(this.getConstantsData, this, ConstantModalComponent, element);
  }

  /**Adds new constant */
  addConstants() {
    this.globalService.openModelWindowSmall(this.getConstantsData, this, ConstantModalComponent, null);
  }

  /**Creates data for filter list */
  createFilterList() {
    let cols: string[] = ['constantId', 'uom', 'lastModifiedBy'];
    for (let a = 0; a < cols.length; a++) {
      let tempFilter: FilterModel = new FilterModel();
      tempFilter.fieldName = this.globalService.replaceDisplayText(cols[a]);
      tempFilter.fieldType = FilterFieldTypes.text;
      let unique;
      if (cols[a] == "constantId") {
        unique = [...new Set(this.constantsDataSource.data.map(a => a.constantId))];
      } else if (cols[a] == "value") {
        tempFilter.fieldType = FilterFieldTypes.values;
        unique = [...new Set(this.constantsDataSource.data.map(a => a.value))];
      } else if (cols[a] == "uom") {
        unique = [...new Set(this.constantsDataSource.data.map(a => a.uom))];
      } else if (cols[a] == "lastModifiedBy") {
        unique = [...new Set(this.constantsDataSource.data.map(a => a.lastModifiedBy))];
      }
      tempFilter.values = unique;
      this.filterList.push(tempFilter);
    }
  }

  /**
   * Returns data from child filter component
   * @param event
   */
  filterResponse(event) {
    let filterResponse: FilterResponseModel = event.filterResponse;
    this.constantsDataSource.data = this.globalService.conditionalDataFiltering(filterResponse, this.constantsDataSource.data);
    this.selectedFilters.push(filterResponse);
    if (this.popover.isOpen()) this.popover.close();
  }

  /**
  * Removes that filter
  * @param selectedFilter
  */
  remove(selectedFilter: FilterResponseModel): void {
    const index = this.selectedFilters.indexOf(selectedFilter);
    if (index >= 0) {
      this.selectedFilters.splice(index, 1);
      this.constantsDataSource.data = this.masterData.slice(0);
      if (this.selectedFilters.length > 0) {
        for (let element of this.selectedFilters) {
          this.constantsDataSource.data = this.globalService.conditionalDataFiltering(element, this.constantsDataSource.data);
        }
      }
    }
  }

}
